var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "100px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.Carrier"),
                          prop: "logisticsCompanyId",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.carrierList,
                            placeholder: _vm.$t(
                              "QuotationCustomerLang.Carrier"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.logisticsCompanyId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsCompanyId",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsCompanyId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "QuotationCustomerLang.EffectiveDateRange"
                          ),
                          prop: "effectiveTime",
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            "tip-show": true,
                            placeholder: _vm.$t(
                              "QuotationCustomerLang.EffectiveDateRange"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryEffectiveTime,
                            callback: function ($$v) {
                              _vm.queryEffectiveTime = $$v
                            },
                            expression: "queryEffectiveTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCustomerLang.AddRate")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          plain: "",
                          disabled:
                            tableOperationProp.notSelected ||
                            _vm.hasSelectedEnabledStatus,
                        },
                        on: { click: _vm.onBatchEnable },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("QuotationCustomerLang.BatchEnable"))
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          plain: "",
                          disabled:
                            tableOperationProp.notSelected ||
                            _vm.hasSelectedDisabledStatus,
                        },
                        on: { click: _vm.onBatchDisable },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("QuotationCustomerLang.BatchDisable"))
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          plain: "",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: { click: _vm.onDelete },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.onDownloadImportTemplate },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("QuotationCustomerLang.ImportTemplate"))
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.onImport },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCustomerLang.Import")))]
                    ),
                    _c(
                      "BjFrontendExport",
                      {
                        attrs: {
                          type: "primary",
                          plain: "",
                          "label-list": _vm.labelList,
                          "get-rows": _vm.getRateExportRows,
                          "file-name": _vm.$t(
                            "QuotationCustomerLang.FuelSurchargeRateFileName"
                          ),
                          "translate-label": "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("QuotationCustomerLang.Export")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop === "surchargeRate"
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "rate-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatRate(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "effectiveFrom" ||
                                        col.prop === "effectiveTo"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  { dateFormat: "DD/MM/YYYY" }
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] == 1
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.STATUS_ENABLED_NUM.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "760px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "quotation-rate-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.RateNo"),
                            prop: "rateCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.RateNo"
                              ),
                              disabled: "",
                            },
                            model: {
                              value: _vm.form.rateCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "rateCode", $$v)
                              },
                              expression: "form.rateCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Carrier"),
                            prop: "logisticsCompanyId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.carrierList,
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Carrier"
                              ),
                            },
                            on: { change: _vm.handleCarrierChange },
                            model: {
                              value: _vm.form.logisticsCompanyId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "logisticsCompanyId", $$v)
                              },
                              expression: "form.logisticsCompanyId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "QuotationCustomerLang.SurchargeRatePercent"
                            ),
                            prop: "surchargeRate",
                          },
                        },
                        [
                          _c("BjInputMoney", {
                            attrs: {
                              min: 1,
                              max: 100,
                              precision: 2,
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.SurchargeRatePercent"
                              ),
                              clearable: "",
                              "not-auto-zero": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [_vm._v("%")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.form.surchargeRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "surchargeRate", $$v)
                              },
                              expression: "form.surchargeRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Status"),
                            prop: "status",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.STATUS_ENABLED_NUM,
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Status"
                              ),
                            },
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "QuotationCustomerLang.EffectiveDateRange"
                            ),
                            prop: "effectiveTime",
                          },
                        },
                        [
                          _c("BjDateRangePicker", {
                            attrs: {
                              "tip-show": true,
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.EffectiveDateRange"
                              ),
                            },
                            model: {
                              value: _vm.formEffectiveTime,
                              callback: function ($$v) {
                                _vm.formEffectiveTime = $$v
                              },
                              expression: "formEffectiveTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Remarks"),
                            prop: "remark",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              maxlength: "500",
                              "show-word-limit": "",
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Remarks"
                              ),
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveRate } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("QuotationCustomerLang.Import"),
            visible: _vm.importDialogVisible,
            width: "520px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
            closed: _vm.resetImportDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "importForm",
              staticClass: "quotation-rate-import-form",
              attrs: {
                model: _vm.importForm,
                rules: _vm.importRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCustomerLang.Carrier"),
                    prop: "logisticsCompanyId",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.carrierList,
                      placeholder: _vm.$t("QuotationCustomerLang.Carrier"),
                    },
                    model: {
                      value: _vm.importForm.logisticsCompanyId,
                      callback: function ($$v) {
                        _vm.$set(_vm.importForm, "logisticsCompanyId", $$v)
                      },
                      expression: "importForm.logisticsCompanyId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCustomerLang.ImportFile"),
                    prop: "file",
                  },
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "importUpload",
                      staticClass: "import-upload",
                      attrs: {
                        drag: "",
                        action: "",
                        accept: ".xls,.xlsx",
                        limit: 1,
                        "file-list": _vm.importFileList,
                        "auto-upload": false,
                        "on-change": _vm.handleImportFileChange,
                        "on-exceed": _vm.handleImportFileExceed,
                        "on-remove": _vm.handleImportFileRemove,
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v(_vm._s(_vm.$t("UploadMainText1"))),
                        _c("em", [_vm._v(_vm._s(_vm.$t("UploadMainText2")))]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onConfirmImport },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }